import cn from "classnames"

import style from "./style.module.scss"

import { Icon } from "components"

export const Header = ({ onGoBack }: { onGoBack?: () => void }) => {
    return (
        <div
            className={cn({
                [style.container]: !onGoBack,
            })}
        >
            <div className="redesign-container">
                <div className={style.header} onClick={onGoBack}>
                    <div>
                        <h1
                            className={cn({
                                [style.headline]: !onGoBack,
                                [style.goBack]: onGoBack,
                            })}
                        >
                            {onGoBack && (
                                <div className={style.icon}>
                                    <Icon type="long-arrow-left-green" size={24} />
                                </div>
                            )}
                            Вход в Мой Alter
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    )
}
